import type { InsuranceDto } from '../../services/api';
import { icon } from '../../icons';
import { t } from '../../services/i18n';
import { esc } from './insurance-dialogs';
import { formatDate } from '../property/property-shared';

export class RcPropertyInsurancesTab extends HTMLElement {
  insurances: InsuranceDto[] = [];

  render(): void {
    const items = this.insurances;
    const now = new Date();
    const soonThreshold = 60 * 24 * 60 * 60 * 1000; // 60 days

    this.innerHTML = `
      <div class="tab-toolbar">
        <button class="btn btn-primary btn-sm" data-action="add-insurance">${icon('plus', { size: 14, strokeWidth: 2.5 })} ${t('insurance.add')}</button>
      </div>
      ${items.length === 0
        ? `<div class="empty-state"><p>${t('insurance.empty')}</p></div>`
        : `<table>
            <thead>
              <tr>
                <th>${t('common.type')}</th>
                <th>${t('insurance.companyName')}</th>
                <th>${t('insurance.policyNumber')}</th>
                <th>${t('common.expiryDate')}</th>
                <th>${t('common.actions')}</th>
              </tr>
            </thead>
            <tbody>
              ${items.map((ins) => {
                const expiry = new Date(ins.expiryDate);
                const isExpired = expiry < now;
                const isSoon = !isExpired && (expiry.getTime() - now.getTime()) < soonThreshold;
                let badgeCls = 'badge-success';
                let badgeLabel = t('common.active');
                if (isExpired) { badgeCls = 'badge-danger'; badgeLabel = t('common.overdue'); }
                else if (isSoon) { badgeCls = 'badge-warning'; badgeLabel = t('common.soon'); }
                return `
                  <tr>
                    <td><span class="fw-medium">${t(`insurance.type.${ins.type}`)}</span></td>
                    <td>${esc(ins.companyName)}</td>
                    <td>${esc(ins.policyNumber)}</td>
                    <td>
                      <span>${formatDate(ins.expiryDate)}</span>
                      <span class="badge ${badgeCls} ml-1">${badgeLabel}</span>
                    </td>
                    <td>
                      <div class="card-actions">
                        <button class="btn btn-outline btn-sm" data-action="edit-insurance" data-id="${ins.id}">${icon('edit', { size: 12, strokeWidth: 2.5 })} ${t('common.edit')}</button>
                        <button class="btn btn-danger btn-sm" data-action="delete-insurance" data-id="${ins.id}">${t('common.delete')}</button>
                      </div>
                    </td>
                  </tr>
                  ${ins.notes ? `<tr><td colspan="5" class="text-sm text-muted">${esc(ins.notes)}</td></tr>` : ''}
                `;
              }).join('')}
            </tbody>
          </table>`}
    `;
  }
}

if (!customElements.get('rc-property-insurances-tab')) {
  customElements.define('rc-property-insurances-tab', RcPropertyInsurancesTab);
}
